import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  GenerateSingleAnswerMutation,
  GenerateSingleAnswerMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";
import { updateBidReportAnswerById } from "../answers/useGetBidReportAnswers";

const generateSingleAnswer = graphql(`
  mutation GenerateSingleAnswer($input: QualifyQuestionRequest!) {
    generateSingleAnswer(QualifyQuestionRequest: $input) {
      answerId
      title
      autoQualify
      answer {
        answer
      }
      sources {
        documentId
        chunkNumber
        locations {
          pageNumber
          bbox {
            x
            y
            width
            height
          }
        }
      }
    }
  }
`);

export function useGenerateSingleAnswer(
  options?: UseMutationOptions<
    GenerateSingleAnswerMutation,
    unknown,
    GenerateSingleAnswerMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(generateSingleAnswer, {
    ...options,
    onSuccess: async (data, vars, ctx) => {
      updateBidReportAnswerById(
        queryClient,
        vars.input.bidReportId,
        data.generateSingleAnswer.answerId,
        data.generateSingleAnswer.answer?.answer ?? "",
      );
      options?.onSuccess?.(data, vars, ctx);
    },
  });

  return { data: data?.generateSingleAnswer, ...rest };
}
